import React, { Component } from 'react';
import $ from "jquery";
import AdminLayout from './../layout';

import { exclprtshipsListPartners, getExclPartnerShipDetailById, saveExclEnqLead } from './../../../API/FetchCall';
import { Player } from 'video-react'; 
import { TwitterIcon, FacebookIcon, InstapaperIcon, LinkedinIcon, EmailIcon } from "react-share";
import { Modal, ModalBody, Row, Col, ModalFooter } from 'reactstrap';
import ModalHeader from 'reactstrap/lib/ModalHeader';

import InstagramIcon from '../instagramicon';


import {
  IMGBASEURL, AZ_ASSET_PATH
} from '../../../constant';

import "./../video-react.css"; 
//import '~video-react/dist/video-react.css';

import closebtn from '../../../../src/assets/icons/close.svg';

class partnerExclusivePartnerShips extends Component {


  constructor(props) {
    super(props);
    this.state = {
      logged: localStorage.getItem("authentication"),
      auth_data: JSON.parse(localStorage.getItem("user_data")),
      exclprtshipsList: [],
      per_page: 15,
      page_number: 1,
      currentpage: 1,
      detailedpreview:false,
      offer3desc:'',
      totalPages: 0,
      contentList: [],
      social_links: [],
      images:[],
      gallery:'',
      title: '',
      content: '',
      descp: '',
      base_url: '',
      banners:'',
      brochures:'',
      gallery:'',
      author_id: 0,
      view_count: 0,
      city: 'bengaluru',
    }

    this.getExclPrtshipsList();
    this.openExclusivePartnerModal = this.openExclusivePartnerModal.bind(this);
    this.closePop = this.closePop.bind(this);
    this.openEnqForm = this.openEnqForm.bind(this);
    this.handleCloseCp = this.handleCloseCp.bind(this);
    this.handleSubmitEnquiry = this.handleSubmitEnquiry.bind(this);
  }

  componentDidMount() {

  }


  openEnqForm = (e) => {
    this.setState({detailedpreview:false, openEnqModal:true});
}

handleChange = (e) => {
  this.setState({ [e.target.name]: e.target.value });
};  

handleSubmitEnquiry = (e) => {

  e.preventDefault();

  let reviewData = JSON.stringify({
    to_email: this.state.emailaddress,
    name: this.state.name,
    first_name: this.state.first_name,
    last_name: this.state.last_name,
    location:this.state.current_location,
    any_message: this.state.any_message,
    reg_email:this.state.reg_email,
    reg_mobile:this.state.reg_mobile,
    source:'exclusivepartnership'
  });
  

  saveExclEnqLead(reviewData).then((response) => {
    if (response.status == 1) {
      
      this.setState({ openEnqModal: false });

      alert("Thank you!, Enquiry is successfully registered");


    }
  });

};  


  closePop(){
    this.setState({detailedpreview:false});
  }

  handleCloseCp = (e) => {
    this.setState({openEnqModal:false});
}

  openExclusivePartnerModal = (e) => {

      let exlpartnerid  = $(e.target).attr('data-id');

      this.setState({detailedpreview:true});

      let req = JSON.stringify({
        id: exlpartnerid
      });
      getExclPartnerShipDetailById(req).then(res => {
        if (res.status === 1) {
          let data = res.detail[0];
          this.setState({
            id: data.id,
            login_id: data.login_id,
            logo: data.logo,
            name:data.name,
            address: data.address,
            emailaddress:data.emailaddress,
            contact_number:data.contact_number,
            title: data.name,
            description: data.description,
            banners: (data.banners!=null)?data.banners:'',
            videos:data.videos,
            videourl:data.videourl,
            gallery:(data.gallery!=null)?data.gallery:'',
            banner_link:data.banner_link,
            website: data.website,
            facebook: data.facebook,
            twitter: data.twitter,
            instagram: data.instagram,
            linkedin:data.linkedin,
            clicktext: data.clicktext,
            link: data.link,
            contenttype: data.contenttype,
            offerimage1:data.offerimage1,
            offerimage2:data.offerimage2,
            offerimage3:data.offerimage3,
            offer1desc:data.offer1desc,
            offer3desc:data.offer3desc,
            offer2desc:data.offer2desc,
            brochures: (data.brochures==null)?'':data.brochures,
            file1: data.file1,
            file2: data.file2,
            thumb1: data.thumb1,
            thumb2: data.thumb2,
            promotion_link: data.promotion_link,
            promotion_image: data.promotion_image,
            description_b2b:data.description_b2b,
            banners_b2b:data.banners_b2b,
            offerimage_b2b:data.offerimage_b2b,
            offerdesc_b2b:data.offerdesc_b2b,
            brochures_b2b:data.brochures_b2b,
            contact_number_b2b:data.contact_number_b2b,
            emailaddress_b2b:data.emailaddress_b2b,
            brochures_b2b_thumb:data.brochures_b2b_thumb,
            view_count: data.view_count
          });
          if(data.id==20){
            this.setState({customexoffersmym:true});
          }
          if(data.id==23){
            this.setState({customexofferslmt:true});
          }
          var sliders = data.banners.split(",");
          var arr2=[];
          var imagesArray = {};
          for(var i=0;i<sliders.length;i++){
              imagesArray['url']=AZ_ASSET_PATH+sliders[i];
              arr2.push(imagesArray);
          }

          this.setState({images:arr2});

        }
      })

  }
  

 


  getExclPrtshipsList = (page_number) => {
    let req = JSON.stringify({
      page_number: page_number ? page_number : this.state.page_number,
      perpage: this.state.per_page
    })
    exclprtshipsListPartners(req).then(res => {
      if (res.status === 1) {
        let data = res.data;
        let total_pages = res.total_pages;
        this.setState({
          exclprtshipsList: data,
          totalPages: total_pages,
          currentpage: res.currentpage,
          page_number: res.currentpage,
          isloading: false
        })
        //window.scrollTo(0, 0);
      }
    })
  }

  render() {


    let newcommentsParm = {
      user_id: this.state.user_id,
      login_id: this.state.login_id,
      id: this.state.id,
    }


    const gallerysettings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            centerMode: false, /* set centerMode to false to show complete slide instead of 3 */
            slidesToScroll: 1
          }
        }
      ]
    };


    const sliders = this.state.banners.split(",");
    const galleries = this.state.gallery.split(",");
    //const IMG_URL = 'http://localhost:5005/';

    const offer1 = (this.state.offerimage1!=null)?AZ_ASSET_PATH+'uploads/'+this.state.offerimage1:null;
    const offer2 = (this.state.offerimage2!=null)?AZ_ASSET_PATH+'uploads/'+this.state.offerimage2:null;
    const offer3 = (this.state.offerimage3!=null)?AZ_ASSET_PATH+'uploads/'+this.state.offerimage3:null;
    /*
    const offer1 = 'https://api.bewise.in/uploads/partner-sujkds.jpg';
    const offer2 = 'https://api.bewise.in/uploads/partner-sujkds.jpg';
    const offer3 = 'https://api.bewise.in/uploads/partner-sujkds.jpg';
    */
    const offer1desc = this.state.offer1desc;
    const offer2desc = this.state.offer2desc;
    const offer3desc = this.state.offer3desc;
    const offerimage_b2b = this.state.offerimage_b2b;
    //const offerdesc_b2b = this.state.offerdesc_b2b;

    const brochures = this.state.brochures.split(",");
    
    const images = JSON.parse(JSON.stringify(this.state.images));

    const banner_link = (this.state.banner_link!=null)?this.state.banner_link:'#';
  
    const modalPlacement = 'top';

      var genafflink = '';
      if(this.state.partner_type==2)  //individual  
      genafflink ='https://bewise.lovemytest.com/profile_registration.php?req=newaccount&profile=bmV3X3NjaG9vbA==&pc=BWS12345&pn='+this.state.name+'&em='+this.state.emailaddress+'&uuid='+this.state.login_id;
      else{
      genafflink ='https://bewise.lovemytest.com/profile_registration.php?req=newaccount&profile=bmV3X3NjaG9vbA==&pc=BWS12345&pn='+this.state.name+'&em='+this.state.emailaddress+'&uuid='+this.state.login_id;
      }    
        const offer3descreplaced =  (offer3desc!=null)?offer3desc.replace('CUSTOMLINK', genafflink):offer3desc;

        const offerdesc_b2b =  (this.state.offerdesc_b2b!=null)?this.state.offerdesc_b2b.replace('CUSTOMLINK', genafflink):this.state.offerdesc_b2b;

        return (
            <React.Fragment>
                <AdminLayout>
                    
                  <div class="col-12 grid-margin">
                    <div class="card">
                      <div class="card-body">
                        <h4 class="card-title">Exclusive Partnerships</h4>
                         
                            <div className='row col-md-12'>
                                  {this.state.exclprtshipsList.map((item, i) => {

                                    return (
                                      <div className='col-md-4 mb-5'>
                                        <div className='exclprtrs-container'>

                                          <div className='topLogo'>
                                            <img src={AZ_ASSET_PATH + item.logo} alt={item.name + ' - Logo'} width="100px" />
                                          </div>
                                          <div className='middleContExcl'>
                                            <h5>{item.name.length > 70 ? item.name.substring(0, 70) + '...' : item.name}</h5>
                                            <div>
                                              <button class="btn btn-primary" onClick={this.openExclusivePartnerModal} data-id={item.id}>view more</button>
                                              { /* <a href={'https://www.bewise.in/partners/'+this.state.auth_data.login_id+'/exclusive-partnerships/' + item.term} class="btn btn-primary btn-sm" title={item.name}>view more</a> */}
                                            </div>
                                          </div>

                                        </div>
                                      </div>
                                    )
                                  })}
                            </div>

                      </div>
                    </div>
                  </div>  


                  <Modal size="lg" isOpen={this.state.detailedpreview} className="modalpopup">
                  <ModalHeader>Exclusive Partnerships - Detail</ModalHeader>
                  <ModalBody className='p-0 detailedpreview'>

                        <div class="onDemandInfo">     


                          <div className="row">
                            <div className="col-lg-12 col-sm-12 col-md-12 col-xs-12">

                              <div class="width100full">
                                

                              <div class="bannerbox">
                                {this.state.banners_b2b!=null &&
                                <img src={AZ_ASSET_PATH+this.state.banners_b2b} class="bannerimage" />
                                }
                                {this.state.banners_b2b==null &&
                                <img src={AZ_ASSET_PATH+this.state.banners} class="bannerimage" />
                                }
                              </div>

                              </div>    

                              
                            </div>
                            
                            

                          </div>
                          

                          <div id="description_section"><h3>About Us</h3>
                             <div class="aboutinfo_fleft">
                               <div class="per20 logobox">
                                <img src={AZ_ASSET_PATH+this.state.logo} className="orgphoto" />
                              </div>
                              <div class="aboutinfo" dangerouslySetInnerHTML={{__html:this.state.description_b2b}}></div>
                            </div>
                          </div>  
                          <br/>

                          <div id="exclusive_offers_section">
                             <h3>Exclusive Offers</h3>
                             <div class="external_affilates_section">

                             
                       
                         <div class="offer_row borderwithcolor1">
                            {offerimage_b2b!=null &&
                             <div class="offer_right_img"><img src={AZ_ASSET_PATH+offerimage_b2b} /></div>
                            }
                            <div class="offer_left_text"><div dangerouslySetInnerHTML={{ __html: offerdesc_b2b}}></div></div>
                         </div>
                         
                              <br/>
                              
                            </div>
                          </div>
                          <div id="brochure_section">
                            <h3>Brochures/Samples</h3>
                            <div>
                             
                            {(this.state.brochures_b2b!='' && this.state.brochures_b2b !=null) && (
                                <a href={AZ_ASSET_PATH+this.state.brochures_b2b} target="_blank">
                                    <img src={AZ_ASSET_PATH+this.state.brochures_b2b_thumb} className="fileicon" />
                                </a>
                            )}
                            </div>
                          </div>
                          <br/>
                          <div id="video_section"><h3>Videos</h3>
                            <div className='row n5v3k'>
                                      {(this.state.videos!==null && this.state.videos!='')? 
                                        <div className="container">
                                          <Player
                                            playsInline
                                            src={AZ_ASSET_PATH + this.state.videos+"#t=0.1"}
                                          /> 
                                          </div>
                                        : <div className="container">Video not available</div>
                                      } 
                              </div>
                          </div>

                          <div id="contactinfo_section">
                          <h3>Contact Info</h3>
                          <div className="col-lg-8 col-sm-12 col-md-12 col-xs-12 text-left">
                                <div class="per100 text-left">
                                    <div class="bs_social">
                                      <div> Email Address: <b>{this.state.emailaddress}</b> </div><br/>
                                      {this.state.website!='' && <div> Website: <b><a href={this.state.website} target="_blank">{this.state.website}</a></b> </div> } <br/>
                                      
                                      {this.state.customexoffersmym && 
                                      <div> Contact Number: <b>7338178936</b> </div>
                                      }

                                      {!this.state.customexoffersmym && 
                                      <div> Contact Number: <b>{this.state.contact_number==''?'N/A':this.state.contact_number}</b> </div>
                                      }


                                      <br/>
                                      <div className="social-icons-container">
                                      <a href={this.state.facebook} target="_blank">
                                        <FacebookIcon size={32} round={true}></FacebookIcon>
                                      </a>
                                      
                                     
                                      &nbsp;
                                      <a href={this.state.instagram} target="_blank">
                                          <InstagramIcon size={32} round={true} />
                                      </a>
                                      </div>
                                    </div>
                                </div>

                                <div><b>For an enquiry</b> &nbsp;<button class="btn btn-primary btn-sm" onClick={this.openEnqForm}>Click here</button></div>
 

                              </div>


                          </div>

                        </div>




                  </ModalBody>
                  <ModalFooter>
                    <button onClick={this.closePop} class="btn btn-primary" >Close</button>
                  </ModalFooter>
                  </Modal>                                  


                  <Modal isOpen={this.state.openEnqModal} centered size='lg' position={modalPlacement} className="modalpopup enquiryform">

<ModalBody>
  <h4 class='csph4'>Contact {this.state.name}</h4>
  <button
    className='close-btn'
    data-dismiss='modal'
    aria-label='Close'
    onClick={this.handleCloseCp}
  >
    <img src={closebtn} alt='close' />
  </button>
  <div class="formbox csp">
    <form
      method='post'
      onSubmit={this.handleSubmitEnquiry}
      autoComplete='off'
      id='loginForm'
    >
      <div
        className='formgroup has-feedback'
        style={{ width: '55%', float: 'left' }}
      >
        <label className='n7tr' >
          First Name
        </label>
        <input
          type='text'
          name='first_name'
          className='form-control' onChange={this.handleChange} required
        />

      </div>
      <div
        className='formgroup has-feedback'
        style={{ width: '40%', float: 'right' }}
      >
        <label className='n7tr' >
          Last Name
        </label>
        <input
          type='text'
          name='last_name'
          className='form-control'  onChange={this.handleChange}  required
        />

      </div>
      <div className='formgroup has-feedback'>
        <label className='n7tr'>
          Mobile Number
        </label>
        <input
          type='tel'
          name='reg_mobile' maxlength='10' minlength='10'
          className='form-control'  onChange={this.handleChange}  required
        />

      </div>
      <div className='formgroup has-feedback'>
        <label className='n7tr'>
          Email ID
        </label>
        <input
          type='email'
          name='reg_email'
          className='form-control'  onChange={this.handleChange}  value={this.state.email_id} required
        />

      </div>

      <div className='formgroup has-feedback'>
        <label className='n7tr'>
          Any Message
        </label>
        <textarea

          name='any_message'
          value={this.state.any_message}  onChange={this.handleChange} 

          className='form-control' required
        />
      </div>

      <div className='formgroup has-feedback'>
        <input
          type='submit'
          name='submit'
          value='Submit'
          className='submit btn btn-primary btn-block btn-css'
        />
      </div>
    </form>
  </div>
</ModalBody>

        </Modal>

                </AdminLayout>
            </React.Fragment>
        )
    }

}

export default partnerExclusivePartnerShips;


// WEBPACK FOOTER //
// ./src/components/bewise/partners/exclusivepartnerships.jsx